var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcArrowDown = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 10.333c-.171 0-.342-.065-.472-.195L4.862 7.471c-.261-.26-.261-.682 0-.942.26-.261.682-.261.942 0l2.204 2.203 2.195-2.12c.266-.255.687-.248.943.017.255.264.248.687-.017.942l-2.666 2.575c-.13.125-.297.187-.463.187z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcArrowDown, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic_arrow_down.b413930e.svg";
export { ForwardRef as ReactComponent };